export const drawerStyles = {
	width: 0.3,
	minWidth: 0.3,
	flexShrink: 0,
	backgroundColor: 'white',
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
	justifyContent: 'center',
}